import { Select } from 'antd';
import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';

import { LANGUAGE } from '@config';
import store from '@core/store/redux';
import { RootState } from '@modules';
import settingStore from '@modules/setting/settingStore';
import { Selector } from '@reduxjs/toolkit';

interface IChangeLanguage {
  language: string;
}

const ChangeLanguageSelector: Selector<RootState, IChangeLanguage> = (state: RootState) => ({
  language: state.settingStore.language,
});

const ChangeLanguage: any = () => {
  // JUST LANGUAGE
  const { language } = useSelector(ChangeLanguageSelector);
  const [searchParams, setSearchParams] = useSearchParams();
  const changeLanguage = (pLanguage: string) => {
    const key: any = pLanguage;
    store.dispatch(settingStore.actions.updateLanguage(key));
    const params = new URLSearchParams(searchParams);
    params.set('language', key);
    setSearchParams(params);
  };

  const options = LANGUAGE.map(({ value, label, icon }) => {
    return {
      value,
      label: (
        <div className="language-wrapper">
          <img src={icon} alt="" className="language-icon" />
          <span className="language-label">{label}</span>
        </div>
      ),
    };
  });

  return (
    <div className={'select-custom select-custom__language'}>
      <Select value={language} options={options} onChange={changeLanguage} />
    </div>
  );
};

export default memo(ChangeLanguage);
